import type { SVGProps } from 'react'
const SvgSyHeart = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M9.527 2.344a6.7 6.7 0 0 0-3.187.228c-1.969.634-3.343 2.059-4.035 3.756s-.735 3.663-.147 5.498v.002C3.1 14.76 5.487 17.17 7.61 18.895a29.5 29.5 0 0 0 4.032 2.761.75.75 0 0 0 .72 0s1.92-1.053 4.05-2.785c2.127-1.731 4.516-4.138 5.43-7.045v-.002c.587-1.835.54-3.801-.154-5.498s-2.068-3.12-4.037-3.754h-.002c-1.928-.619-4.017-.224-5.646.834-.768-.492-1.586-.912-2.475-1.062m-.25 1.48a5.24 5.24 0 0 1 2.272.973.75.75 0 0 0 .91-.006c1.24-.96 3.13-1.304 4.73-.791 1.55.499 2.564 1.556 3.112 2.895.547 1.338.596 2.96.111 4.474v.004c-.756 2.403-2.93 4.693-4.947 6.334-1.828 1.487-3.173 2.22-3.467 2.387-.294-.165-1.621-.885-3.441-2.364-2.01-1.632-4.187-3.92-4.971-6.36-.485-1.516-.438-3.137.107-4.475C4.24 5.557 5.253 4.499 6.801 4a5.2 5.2 0 0 1 2.476-.176"
				clipRule="evenodd"
			/>
			<path
				d="M16.23 5.986a.75.75 0 0 0-.943.483.75.75 0 0 0 .483.945 2.03 2.03 0 0 1 1.4 1.77.75.75 0 0 0 .809.685.75.75 0 0 0 .685-.808 3.535 3.535 0 0 0-2.434-3.075"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyHeart
